import { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './header';
import { AdminSidebar } from './admin-sidebar';
import { GlobalSearch } from './global-search';
import { RouteLoadingFallback } from './route-loading-fallback';

export function AppShell() {
  const { pathname } = useLocation();
  const isTicketDetail = /^\/tickets\/[^/]+$/.test(pathname) && pathname !== '/tickets/new';

  return (
    <div className="flex h-screen flex-col">
      <Header />
      <div className="flex flex-1 overflow-hidden">
        <AdminSidebar />
        <main
          className={isTicketDetail
            ? 'min-h-0 min-w-0 flex-1 overflow-hidden bg-surface-page'
            : 'min-w-0 flex-1 overflow-y-auto bg-surface-page p-4 sm:p-6'}
          id="main-content"
          tabIndex={-1}
        >
          <Suspense fallback={<RouteLoadingFallback />}>
            <Outlet />
          </Suspense>
        </main>
      </div>
      <GlobalSearch />
    </div>
  );
}
